/* eslint-disable import/no-anonymous-default-export */
import ManageBond from "../pages/treasury/bond/ManageBond";
import AddBond from "../pages/treasury/bond/AddNewBond";
import EditBond from "../pages/treasury/bond/EditBond";
import ViewBond from "../pages/treasury/bond/ViewBond";
import ManageTreasuryBill from "../pages/treasury/treasuryBill/ManageTreasuryBill";
import AddTreasuryBill from "../pages/treasury/treasuryBill/AddTreasuryBill";
import ManageInterBankPlacement from "../pages/treasury/interBankPlacement/ManageInterBankPlacement";
import CreateInterBankPlacement from "../pages/treasury/interBankPlacement/CreateInterBankPlacement";
// import CreateInterBankPlacement from "../pages/treasury/interBankPlacementNew/NewInterBankPlacement";
import ViewInterBankPlacement from "../pages/treasury/interBankPlacement/ViewInterBankPlacement";
import EditInterBankPlacement from "../pages/treasury/interBankPlacement/EditInterBankPlacement";
import ViewTreasuryBill from "../pages/treasury/treasuryBill/ViewTreasuryBill";
import EditTreasuryBill from "../pages/treasury/treasuryBill/EditTreasuryBill";
import ManageSecurityProduct from "../pages/products/securityProduct/ManageSecurityProduct";
import ManageAuction from "../pages/treasuryContractBooking/auction/ManageAuction";
import AddAution from "../pages/treasuryContractBooking/auction/AddAuction";

import ViewAuction from "../pages/treasuryContractBooking/auction/ViewAuction.js";
import AddAuctionLine from "../pages/treasuryContractBooking/auction/action/AddAuctionLine.js";
import Createauctionallotment from "../pages/treasuryContractBooking/auction/action/Createauctionallotment.js";
import Createauctionbid from "../pages/treasuryContractBooking/auction/action/Createauctionbid.js";
import Recordauctionresults from "../pages/treasuryContractBooking/auction/action/Recordauctionresults.js";
import ManageTrade from "../pages/treasuryContractBooking/trade/ManageTrade.js";
import AddTrade from "../pages/treasuryContractBooking/trade/AddTrade.js";
import ViewTrade from "../pages/treasuryContractBooking/trade/ViewTrade.js";
import ConfirmTrade from "../pages/treasuryContractBooking/trade/action/ConfirmTrade.js";
import CancelTrade from "../pages/treasuryContractBooking/trade/action/CancelTrade.js";
import ConvertAllotmentToTrade from "../pages/treasuryContractBooking/trade/action/ConvertAllotmentToTrade.js";
import ManageSettlement from "../pages/treasuryContractBooking/settlement/ManageSettlement.js";
import AddSettlement from "../pages/treasuryContractBooking/settlement/AddSettlement.js";
import ViewSettlement from "../pages/treasuryContractBooking/settlement/ViewSettlement.js";
import ConfirmSettlement from "../pages/treasuryContractBooking/settlement/actions/ConfirmSettlement.js";
import Failsettlement from "../pages/treasuryContractBooking/settlement/actions/FailSettlement.js";
import AddTreasuryBillContract from "../pages/treasuryContractBooking/treasuryBillContract/AddTreasuryBillContract.js";
import ManageTreasuryBillContracts from "../pages/treasuryContractBooking/treasuryBillContract/ManageTreasuryBillContracts.js";
import ApproveContract from "../pages/treasuryContractBooking/treasuryBillContract/actions/ApproveContract.js";
import DisburseContract from "../pages/treasuryContractBooking/treasuryBillContract/actions/DisburseContract.js";
import PrematureRedemption from "../pages/treasuryContractBooking/treasuryBillContract/actions/PrematureRedemption.js";
import RejectContract from "../pages/treasuryContractBooking/treasuryBillContract/actions/RejectContract.js";
import RolloverContract from "../pages/treasuryContractBooking/treasuryBillContract/actions/RolloverContract.js";
import ManageBondContract from "../pages/treasuryContractBooking/bondContract/ManageBondContract.js";
import AddBondContract from "../pages/treasuryContractBooking/bondContract/AddBondContract.js";
import ViewBondContract from "../pages/treasuryContractBooking/bondContract/ViewBondContract.js";

export default [
  {
    path: "/bond-product",
    component: ManageBond,
  },
  {
    path: "interbank-placement",
    component: ManageInterBankPlacement,
    isProtected: true,
  },
  {
    path: "add-interbank-placement",
    component: CreateInterBankPlacement,
    isProtected: true,
  },
  {
    path: "view-interbank-placement",
    component: ViewInterBankPlacement,
    isProtected: true,
  },
  {
    path: "edit-interbank-placement",
    component: EditInterBankPlacement,
    isProtected: true,
  },
  {
    path: "/new-bond-product",
    component: AddBond,
    isProtected: true,
  },
  {
    path: "/edit-bond-product",
    component: EditBond,
    isProtected: true,
  },
  {
    path: "/detail-bond-product",
    component: ViewBond,
    isProtected: true,
  },
  // -- TREASURY BILL --
  {
    path: "/treasury-bill",
    component: ManageTreasuryBill,
    isProtected: true,
  },
  {
    path: "/new-treasury-bill",
    component: AddTreasuryBill,
    isProtected: true,
  },
  {
    path: "/view-treasury-bill",
    component: ViewTreasuryBill,
    isProtected: true,
  },
  {
    path: "/edit-treasury-bill",
    component: EditTreasuryBill,
    isProtected: true,
  },

  // Treasury Contract booking (auction)

  {
    path: "/auction",
    component: ManageAuction,
    isProtected: true,
  },

  {
    path: "/add-auction",
    component: AddAution,
    isProtected: true,
  },
  
  {
    path: "/edit-auction",
    component: AddAution,
    isProtected: true,
  },
  
  {
    path: "/view-auction",
    component:ViewAuction,
    isProtected: true,
  },

  {
    path: "/add-auction-line",
    component:AddAuctionLine,
    isProtected: true,
  },
  {
    path: "/create-auction-allotment",
    component:Createauctionallotment,
    isProtected: true,
  },
  {
    path: "/create-aution-bid",
    component:Createauctionbid,
    isProtected: true,
  },
  {
    path: "/record-auction-result",
    component:Recordauctionresults,
    isProtected: true,
  },

  // Treasury Contract booking (auction)
 {
    path: "/trade",
    component:ManageTrade,
    isProtected: true,
  },
   {
    path: "/add-trade",
    component:AddTrade,
    isProtected: true,
  },
   {
    path: "/edit-trade",
    component:AddTrade,
    isProtected: true,
  },  
   {
    path: "/view-trade",
    component:ViewTrade,
    isProtected: true,
  },
   {
    path: "/trade/confirm",
    component:ConfirmTrade,
    isProtected: true,
  },
   {
    path: "/trade/cancel",
    component:CancelTrade,
    isProtected: true,
  },
   {
    path: "/trade/convert-allotment",
    component:ConvertAllotmentToTrade,
    isProtected: true,
  },

  
   {
    path: "/settlement",
    component:ManageSettlement,
    isProtected: true,
  },
   {
    path: "/add-settlement",
    component:AddSettlement,
    isProtected: true,
  },
   {
    path: "/edit-settlement",
    component:AddSettlement,
    isProtected: true,
  },
   {
    path: "/view-settlement",
    component:ViewSettlement,
    isProtected: true,
  },
   {
    path: "/settlement/confirm",
    component:ConfirmSettlement,
    isProtected: true,
  },
   {
    path: "/settlement/fail",
    component:Failsettlement,
    isProtected: true,
  },


   {
    path: "/treasury-bill-contract",
    component:ManageTreasuryBillContracts,
    isProtected: true,
  },

   {
    path: "/add-treasury-bill-contract",
    component:AddTreasuryBillContract,
    isProtected: true,
  },
   {
    path: "/edit-treasury-bill-contract",
    component:AddTreasuryBillContract,
    isProtected: true,
  },
   {
    path: "/treasury-bill-contract/approve",
    component:ApproveContract,
    isProtected: true,
  },
   {
    path: "/treasury-bill-contract/premature-redemption",
    component:PrematureRedemption,
    isProtected: true,
  },
   {
    path: "/treasury-bill-contract/disburse",
    component:DisburseContract,
    isProtected: true,
  },
   {
    path: "/treasury-bill-contract/reject",
    component:RejectContract,
    isProtected: true,
  },
  
   {
    path: "/treasury-bill-contract/rollover",
    component:RolloverContract,
    isProtected: true,
  },

  
   {
    path: "/bond-contract",
    component:ManageBondContract,
    isProtected: true,
  },

   {
    path: "/add-bond-contract",
    component:AddBondContract,
    isProtected: true,
  },

   {
    path: "/edit-bond-contract",
    component:AddBondContract,
    isProtected: true,
  },

   {
    path: "/view-bond-contract",
    component:ViewBondContract,
    isProtected: true,
  },


];
